import{t as o}from"./index-69e2c5c3.js";import"emotion";import{_ as t}from"./index-c123ab12.js";export default function(r){return t(o(r))}
